// removed by extract-text-webpack-plugin
module.exports = {"skeleton":"styles__skeleton___Ryhas","skeleton-loading":"styles__skeleton-loading___MnABB","whiteBackgroundSkeleton":"styles__whiteBackgroundSkeleton___3eijc","table":"styles__table___HYZtZ","skeletonText":"styles__skeletonText___1vlhR","tableHeader":"styles__tableHeader___PwD1L","itemValue":"styles__itemValue___9p6Pa","itemsClasses":"styles__itemsClasses___2qLS-","tableBody":"styles__tableBody___2K7Bb","mainSectionSkeleton":"styles__mainSectionSkeleton___30xTb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skeleton/HistoryOnlineInterfaceSkeleton/styles.css
// module id = 2528
// module chunks = 0